import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../Layout";
import QCSpecification from "../Components/Production/QCSpecification";
import List from "../Components/Batch Release/List";
import Add from "../Components/Batch Release/Add";

function BatchRelease() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState();
  const location = useLocation();

  useEffect(() => {
    setComp("list");
  }, [location]);

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }

  function renderComponent() {
    switch (comp) {
      case "list":
        return <List comp={comp} onChange={handleChange} rowData={rowData} />;
      //   case "view":
      //     return <View comp={comp} rowData={rowData} onChange={handleChange} />;
      //   case "QCSpecification":
      //     return <QCSpecification comp={comp} rowData={rowData} onChange={handleChange} />;
      default:
        return <Add comp={comp} rowData={rowData} onChange={handleChange} />;
    }
  }

  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Batch Release</h1>
          </div>
          {renderComponent()}
        </section>
      </div>
    </Layout>
  );
}

export default BatchRelease;
